class SizeChartDialog extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.render();
    this.setupComponent();
  }

  render() {
    this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: block;
          }
  
          dialog {
            background: rgb(var(--color-background));
            border-radius: var(--popup-corner-radius);
            padding: 2.5rem;
            width: 95%;
            max-width: var(--page-width);
            border: 0.1rem solid rgba(var(--color-foreground), 0.08);
          }
  
          dialog::backdrop {
            background: rgba(0, 0, 0, 0.5);
          }
  
          dialog:focus {
            outline: none;
          }
  
          dialog[open] {
            animation: dialog-show 0.3s ease-out;
          }
  
          @keyframes dialog-show {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
  
          .header-container {
            display: flex;
            justify-content: space-between;
            align-items: start;
          }
  
          .heading {
            margin: 0;
            font-size: calc(var(--font-heading-scale) * 2rem);
            line-height: 1.3;
            margin-bottom: 1.5rem;
          }
  
          .description {
            color: rgba(var(--color-foreground), 0.75);
            margin-bottom: 2.5rem;
            line-height: 1.6;
          }
  
          .table-container {
            position: relative;
            width: 100%;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            background: rgb(var(--color-background));
          }
  
          ::slotted(table) {
            width: 100% !important;
            table-layout: fixed;
            border-collapse: collapse;
            text-align: center;
            border-style: hidden;
            font-size: 1.4rem;
            display: table;
          }
  
          ::slotted(table) th,
          ::slotted(table) td {
            padding: 1.2rem 1.5rem;
            text-align: left;
            border: 0.1rem solid rgba(var(--color-foreground), 0.08);
            white-space: nowrap;
          }
  
          ::slotted(table) th {
            background: rgba(var(--color-foreground), 0.03);
            font-weight: 500;
          }
  
          ::slotted(table) tr:hover {
            background: rgba(var(--color-foreground), 0.01);
          }
          
          .close-button {
            background: none;
            border: none;
            cursor: pointer;
            padding: 0.5rem;
          }
  
          @media screen and (max-width: 749px) {
            dialog {
              padding: 2rem;
              margin: 2rem 0;
            }
  
            .heading {
              font-size: calc(var(--font-heading-scale) * 1.8rem);
              margin-bottom: 1rem;
            }
  
            .description {
              margin-bottom: 2rem;
            }
  
            th, td {
              padding: 1rem;
            }
          }
        </style>
  
        <dialog part="dialog">
          <div class="header-container">
            <div>
              <h2 class="heading"><slot name="title"></slot></h2>
              <div class="description"><slot name="description"></slot></div>
            </div>
            <button class="close-button" type="button">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                <path d="M15.89 14.696l-4.89-4.89 4.89-4.89a1 1 0 00-1.415-1.414L9.586 8.39l-4.89-4.89a1 1 0 00-1.414 1.415l4.89 4.89-4.89 4.89a1 1 0 001.414 1.414l4.89-4.89 4.89 4.89a1 1 0 001.414-1.414z"/>
              </svg>
            </button>
          </div>
  
          <div class="table-container">
            <slot name="table"></slot>
          </div>
        </dialog>
      `;
  }

  setupComponent() {
    this.dialog = this.shadowRoot.querySelector("dialog");
    this.closeButton = this.shadowRoot.querySelector("button.close-button");

    this.closeButton.addEventListener("click", (e) => {
      this.close();
    });

    this.dialog.addEventListener("cancel", (e) => {
      e.preventDefault();
      this.close();
    });

    if (!window.sizeChart) {
      window.sizeChart = {
        open: () => this.open(),
        close: () => this.close(),
      };
    }
  }

  open() {
    if (!this.dialog.open) {
      this.dialog.showModal();
      this.dispatchEvent(new CustomEvent("size-chart-opened"));
    }
  }

  close() {
    if (this.dialog.open) {
      this.dialog.close();
      this.dispatchEvent(new CustomEvent("size-chart-closed"));
    }
  }
}

customElements.define("size-chart-dialog", SizeChartDialog);
